import GlobalNavItems from './GlobalNavItems';

export default GlobalNavItems;
